import { render } from "./SupplyOrderDetails.vue?vue&type=template&id=70d46ffc&scoped=true"
import script from "./SupplyOrderDetails.vue?vue&type=script&lang=js"
export * from "./SupplyOrderDetails.vue?vue&type=script&lang=js"

import "./SupplyOrderDetails.vue?vue&type=style&index=0&id=70d46ffc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d46ffc"]])

export default __exports__